import { useState } from 'react';
import MarcaLogo from '@/components/layout/MarcaLogo';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import { usandoEmuladores } from '@/lib/firebase';

const MENSAGENS = {
  'auth/invalid-credential': 'E-mail ou senha incorretos.',
  'auth/invalid-email': 'E-mail inválido.',
  'auth/user-disabled': 'Este usuário está desativado. Fale com o gestor da clínica.',
  'auth/too-many-requests': 'Muitas tentativas. Aguarde alguns minutos e tente de novo.',
  'auth/network-request-failed': usandoEmuladores
    ? 'Sem conexão com o emulador. Rode "npm run emu" na raiz do projeto.'
    : 'Falha de conexão. Verifique sua internet.',
};

export default function LoginPage() {
  const { autenticado, entrar } = useAuth();
  const local = useLocation();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState(null);
  const [enviando, setEnviando] = useState(false);

  if (autenticado) return <Navigate to={local.state?.de ?? '/'} replace />;

  async function aoEnviar(evento) {
    evento.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email.trim(), senha);
    } catch (e) {
      setErro(MENSAGENS[e.code] ?? 'Não foi possível entrar. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="tela-login">
      <form className="cartao-login" onSubmit={aoEnviar}>
        <div className="marca marca-grande">
          <MarcaLogo />
          <span className="marca-nome">OdontoSDR</span>
        </div>
        <p className="subtitulo">Central de atendimento e gestão de leads</p>

        <label htmlFor="email">E-mail</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="senha">Senha</label>
        <input
          id="senha"
          type="password"
          autoComplete="current-password"
          required
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />

        {erro && <p className="erro">{erro}</p>}

        <button type="submit" className="btn-primario" disabled={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>

        {usandoEmuladores && (
          <p className="dica-emulador">
            Ambiente local. Use as contas criadas por <code>npm run seed</code>.
          </p>
        )}
      </form>
    </div>
  );
}
